import { useTranslation } from 'react-i18next';

import type { ReactElement } from 'react';
import type IAiChatDatasourceEmpty from '../interfaces/IAiChatDatasourceEmpty';

import styles from '../sass/AiChat.module.scss';

/**
 * Where a table or a chart would be, when the datasource's rows were dropped and its statement
 * can no longer run: the route's reason, in the display's place in the chat. Not an error line —
 * the read worked, the rows are what is gone — and never a toast.
 */
function AiChatDatasourceEmpty({ reason }: IAiChatDatasourceEmpty): ReactElement {
  const { t } = useTranslation();

  return <p className={styles.note}>{reason || t('aiChat.tools.datasourceDropped')}</p>;
}

export default AiChatDatasourceEmpty;
